import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { useCallback, useEffect } from 'react';
import useMountedState from 'react-use/lib/useMountedState';
import { OpenModalContainer } from '../../../components/openModalContainer';
import { isConfigFlagEnabled } from '../../../config';
import { useSocketSend } from '../../../context/webSocket/webSocketContext';
import { setCreateGameName, setCreateGameSpeedIndex } from '../../../redux/actions/createGameActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { getGameSpeedIndex } from '../../../types/pokerTypes';
import { isTestEnvironment } from '../../../utils/utils';
import { AggroBettingFilterControl } from './aggroBettingFilterControl';
import { BuyInControlSet } from './buyInControlSet';
import { LimitTypeControl } from './limitTypeControl';
import { MiscGameSettingsControlSet } from './miscGameSettingsControlSet';
import { PowerPlayersOnlyControlContainer } from './powerPlayersOnlyControlContainer';
import { RoomNameControl } from './roomNameControl';
import { RoomTypeControlSet } from './roomTypeControlSet';
import { SideBetsPhaseControl } from './sideBetsPhaseControl';
export const CreateGameModal = ({ onClose }) => {
    const dispatch = useAppDispatch();
    const isMounted = useMountedState();
    const socketSend = useSocketSend();
    const outbound = useAppSelector((state) => state.createGame.outbound);
    const selfUsername = useAppSelector((state) => state.selfData.username);
    const onClickCreate = useCallback(() => {
        socketSend(outbound);
    }, [outbound, socketSend]);
    useEffect(() => {
        dispatch(setCreateGameName(`${selfUsername}'s Game`));
        if (isTestEnvironment()) {
            dispatch(setCreateGameSpeedIndex(getGameSpeedIndex('ludicrous')));
        }
    }, [dispatch, selfUsername]);
    return (_jsxs(OpenModalContainer, { title: 'Create Game', onClose: onClose, children: [_jsxs(DialogContent, { children: [_jsx(RoomNameControl, {}), _jsx(RoomTypeControlSet, {}), _jsx(BuyInControlSet, {}), _jsx(MiscGameSettingsControlSet, {}), _jsx(PowerPlayersOnlyControlContainer, {}), isConfigFlagEnabled('dualLimitGameSetting') ? _jsx(LimitTypeControl, {}) : _jsx(AggroBettingFilterControl, {}), _jsx(SideBetsPhaseControl, {})] }), _jsx(DialogActions, { children: _jsx(Button, { "data-testid": 'create-game-button', onClick: onClickCreate, variant: 'contained', disabled: !isMounted, children: "Create" }) })] }));
};
